import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { LoadingPage } from '@/components/ui/loading-page';
import { dynamicFormsApi } from '@/lib/api/dynamic-forms';

export default function FormNewPage() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await dynamicFormsApi.create({ title: 'Untitled form' });
        if (cancelled) return;
        if (res.statusCode !== 201) {
          throw new Error(res.message || 'Could not create form');
        }
        navigate(`/f/${res.data.form._id}/edit`, { replace: true });
      } catch (e) {
        if (!cancelled) {
          toast.error(e instanceof Error ? e.message : 'Could not create form');
          navigate('/f', { replace: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return <LoadingPage message="Creating form…" />;
}
